import PropTypes from 'prop-types';
import SceneToggleButton from './SceneToggleButton';

function ModelToggle({
    toggle,
}) {
    return (
        <SceneToggleButton
            ariaLabel={toggle.ariaLabel}
            className={`scene-toggle toggle-model is-${toggle.state}`}
            disabled={toggle.disabled}
            onClick={toggle.onClick}
            title={toggle.title}
        >
            <>
                <span className="scene-toggle-icon-shell" aria-hidden="true">
                    <span className="toggle-model-icon-stack">
                        <span className={`toggle-model-pill ${(toggle.state === 'stl' || toggle.state === 'mixed') ? 'selected' : ''}`}>
                            STL
                        </span>
                        <span className={`toggle-model-pill ${(toggle.state === 'ply' || toggle.state === 'mixed') ? 'selected' : ''}`}>
                            PLY
                        </span>
                    </span>
                </span>
                <span>Model</span>
            </>
        </SceneToggleButton>
    );
}

ModelToggle.propTypes = {
    toggle: PropTypes.shape({
        ariaLabel: PropTypes.string.isRequired,
        disabled: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        state: PropTypes.oneOf([
            'disabled',
            'mixed',
            'ply',
            'stl',
        ]).isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

export default ModelToggle;
